// Tile de KPI del Dashboard — grid flat, etiqueta mono arriba + valor grande
// abajo, mismo patrón que el resto de "tiles de datos" de la línea de
// diseño Clinical Instrument (ver signos vitales de FacesheetTab.tsx).
import type { JSX } from 'react';

export function KpiTile({ label, valor }: { label: string; valor: number | undefined }): JSX.Element {
  return (
    <div className="rounded-md border border-border bg-hce-paper p-3">
      <div className="text-[11px] font-mono uppercase tracking-wide text-hce-muted">{label}</div>
      <div className="mt-1 text-2xl font-medium text-hce-ink">{valor ?? '—'}</div>
    </div>
  );
}
